export default "__VITE_ASSET__CDGB85s8__"